module.exports = __webpack_public_path__ + "static/media/map.1cbb0d32.jpg";